import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Query } from "@types";

export const useGetExamPeriods = (query: Query, enabled: boolean = true) => {

    const axios = useAxios();
    const { t } = useTranslation();

    const fetchExamPeriods = async () => {
        try {
            const { data } = await axios.get("/api/examterms", {params: query});
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getExamPeriods"));
        }
    }

    return useQuery({queryKey: ["examPeriods", query], queryFn: fetchExamPeriods, enabled});
    
}